import isEmpty from '#src/client/common/utils/isEmpty.js';
import { splitProps } from 'solid-js';
import colors from '#src/client/common/colors.js';
import style from '#src/client/common/interactive/Button.module.css';
import sizes from '#src/client/common/interactive/sizes.js';

function Button(props) {
    const [local, others] = splitProps(props, [
        'size',
        'color',
        'class',
        'style',
    ]);

    const getSize = () => {
        const size = !isEmpty(local.size) ? local.size : sizes.default.name;
        return sizes[size] ? sizes[size].size : size;
    };

    const getColor = () => {
        const color = !isEmpty(local.color) ? local.color : colors.primary;
        return colors[color] ? style[color] : color;
    };

    const classes = () => {
        return [
            local.class ?? '',
            style.button,
            getColor(),
        ].join(' ');
    };

    const styles = () => {
        return {
            ...local.style,
            '--size': getSize(),
        };
    };

    return (
        <button
            tabindex="0"
            type="button"
            {...others}
            style={styles()}
            class={classes()}><span class={style.content}>{props.children}</span></button>
    );
}

export default Button;
